import { FormContextValues, Translate } from '@dreryk/react-common';
import { Toggle } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

const RECURRENCE_FIELD_NAME = 'recurrence';

type RecurrenceFieldProps = Pick<FormContextValues<RecurrenceFormBeanPart>, 'register'>;
type RecurrenceFormBeanPart = {
   [RECURRENCE_FIELD_NAME]?: boolean;
};

export const RecurrenceToggleField = (props: RecurrenceFieldProps): JSX.Element => {
   return (
      <Toggle
         controller={props.register(RECURRENCE_FIELD_NAME)}
         testId={RECURRENCE_FIELD_NAME}
         rightSlot={<Translate>{appointmentsTranslationKeys.create.form.recurrence}</Translate>}
      />
   );
};
